// extracted by mini-css-extract-plugin
module.exports = {"downloadOptions":"downloadDropdown_downloadOptions__10iN5","active":"downloadDropdown_active__2JTA2"};